export const LOGIN_REQUEST = "user::login::request";
export const LOGIN_SUCCESS = "user::login::success";
export const DISCONNECT_SUCCESS = "user::disconnect::success";
export const INFOS_REQUEST = "user::infos::request";
export const INFOS_SUCCESS = "user::infos::success";
export const SET_TOKEN = "user::set::token";
export const SET_EMAIL = "user::set::email";
export const INIT_PARAMS = "user::params::init";
